export default {
    appVersion(state) {
        return state.packageVersion;
    },
    session_validity(state) {
        return state.session_validity;
    },
    server_status(state) {
        return state.server_status;
    },
    appInitialiazed(state) {
        return state.initialized;
    },
    userIsAuthenticated(state) {
        return state.isLoggedIn;
    },
    userid(state) {
        return state.userid;
    },
    customer(state) {
        return state.customer;
    },
    storeCatalog(state){
        return state.storeCatalog.toUpperCase();
    },
    storeConfigID(state){
        return state.storeConfigID;
    },
    hosturl(state) {
        if (state.hosturl.toUpperCase().includes('LOCALHOST')) {
            // console.log(state);
            // return state.envurl.toUpperCase();
            return 'TEST.QWIK-ORDERPLUS.COM';
        } else {
            return state.hosturl.toUpperCase();
        }
    },

    desktop_logo(state){
        return state.desktop_logo;
    },

    mobile_logo(state){
        return state.mobile_logo;
    },

    slider_url(state){
        return state.slider_url;
    },

    storefront(state){
        return state.storefront;
    },

    defaultB2Ccustomer(state) {
        return state.defaultB2Ccustomer;
    },
    customerIndicator(state) {
        return state.customerIndicator;
    },
    storefrontAttributes(state) {
        return state.storefrontAttributes;
    },
    userAttributes(state) {
        return state.userAttributes;
    },

    getCustomerDetails(state) {
        return state.customerdetails;
    },

    getDefaultLocationDetails(state) {
        return {
            "defaultlocationid": state.customerdetails.defaultlocationid,
            "defaultlocationname": state.customerdetails.defaultlocationname,
            "defaultlocationcity": state.customerdetails.defaultlocationcity,
            "defaultlocationstate": state.customerdetails.defaultlocationstate
        }
    },

    passwords (state) {
        return {
            newpassword : state.newPassword,
            repassword : state.rePassword,
        }
    },

    image_domain_category (state) {
        return state.IMG_SCHEME + '://' + state.IMG_DOMAIN + '/' + state.CAT_URI
    },

    languages (state) {
        return state.languages;
    },

    errorFields (state) {
        return state.errorFields;
    },

    custB2BLocations (state) {
        return state.custB2BLocations;
    },

    mfgs_imgs (state) {
        return state.mfgs_imgs;
    },

    cat_img_level_1 (state) {
        return state.cat_img_level_1;
    },

    wd_mfgs (state) {
        return state.wd_mfgs;
    },

    wd_mfgxs (state) {
        return state.wd_mfgxs;
    },

    custInfoEnrolled (state) {
        return state.custInfoEnrolled;
    },

    cl_cloudname (state) {
        return state.cl_cloudname;
    },

    cl_api_key (state) {
        return state.cl_api_key;
    },

    cl_secret_key (state) {
        return state.cl_secret_key;
    },

    cl_api_url (state) {
        return 'https://' + state.cl_api_key + ':' + state.cl_secret_key + state.cl_api_url + state.cl_cloudname;
    },

    customerDefaultCC(state) {
        return state.customerDefaultCC;
    },

    typahead_str(state){
        return state.typahead_str;
    },

    solr_hostname(state){
        return state.solr_hostname;
    },

    solr_coreadmin(state){
        return state.solr_coreadmin;
    },

    solr_faceted_filter(state){
        return state.solr_faceted_filter;
    },

    cat_faceted_filter(state){
        return state.cat_faceted_filter;
    },

    solr_username(state){
        return state.solr_username;
    },

    solr_password(state){
        return state.solr_password;
    },

    rma_enabled(state) {
        return state.rma_enabled;
    },
}